<div class="flex flex-col h-full">
  <div
    class="flex justify-between items-center mb-lg"
    [class]="
      floating()
        ? systemTabs()
          ? ''
          : 'mt-xl'
        : 'py-lg border-b border-neutral-200 mt-2xl'
    ">
    <div class="flex items-center gap-lg">
      <h5 class="text-neutral-900 font-semibold text-lg">
        {{ 'variables_screen_subtitle' | transloco }}
      </h5>

      <lib-badge
        label="{{ totalItems() }}"
        [badgeClass]="'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'" />
    </div>

    <!-- Tables_new_design shows the search in the table toolbar instead -->
    @if (!searchInToolbar()) {
      <ng-container [ngTemplateOutlet]="variablesSearch" />
    }
  </div>

  <ng-template #variablesSearch>
    <lib-search-field
      class="shrink-0"
      [searchInputWidth]="searchInputWidth"
      [placeholder]="'search_by_name_placeholder'"
      (searchKeywordEmitter)="onSearchTermChange($event)" />
  </ng-template>

  <lib-table
    [tableClass]="'min-h-[calc(100vh-33rem)] h-auto w-full whitespace-nowrap'"
    [id]="'variables'"
    [dataSource]="variableList()"
    [loading]="isLoading()"
    [columns]="columns()"
    [noDataTitle]="'table_no_data_title' | transloco"
    [noDataDescription]="'section_no_data_description' | transloco"
    [tableFilterTabs]="tableFilterTabs()"
    [searchTemplateRef]="searchInToolbar() ? variablesSearch : null"
    [lastColumnAlignment]="'justify-end'"
    (handleSortColumn)="handleSortColumn($event)"
    [bodyTabTemplateRef]="[
      { template: number },
      { template: variable },
      { template: allValues },
      { template: activeValues },
      { template: action },
    ]"
    [titleBottomBorder]="false">
    <ng-template #number let-row let-i="i">
      {{ (currentPage() - 1) * currentSize() + (i + 1) }}
    </ng-template>

    <ng-template #variable let-row>
      {{ row.name }}
    </ng-template>

    <ng-template #allValues let-row>
      {{ row.total_options_count }}
    </ng-template>

    <ng-template #activeValues let-row>
      {{ row.active_options_count }}
    </ng-template>

    <ng-template #action let-row>
      <lib-action-list
        [parentName]="'variables'"
        [menuItems]="getViewActionList(row.id)"
        (itemClick)="actionListItemClick($event, row)"></lib-action-list>
    </ng-template>
  </lib-table>

  @if (variableList().length) {
    <div [class]="floating() ? 'pt-2xl' : 'py-2xl'">
      <lib-paginator
        [sizeOptionsLabel]="
          'pagination_number_of_rows_per_page_label' | transloco
        "
        [nextBtnLabel]="'pagination_next_button_label' | transloco"
        [previousBtnLabel]="'pagination_previous_button_label' | transloco"
        [currentPage]="currentPage()"
        [totalPages]="totalPages()"
        [totalItems]="totalItems()"
        [showChangeSize]="true"
        [sizeOptions]="pageSizeOptions"
        (goTo)="handlePagination($event)"
        (next)="handlePagination($event)"
        (previous)="handlePagination($event)"
        (handleChangeSize)="changeSize($event)"
        [currentSize]="currentSize()"></lib-paginator>
    </div>
  }
</div>
